import { useQueryClient } from '@tanstack/react-query'

type UseInvalidateIGAOResult = () => Promise<void>

export function useInvalidateIGAO (path: string): UseInvalidateIGAOResult {
  const queryClient = useQueryClient()
  async function invalide (): Promise<void> {
    await queryClient.invalidateQueries({
      queryKey: [
        'igao',
        path
      ]
    })
  }

  return invalide
}
